import { axios } from '@/libs/request'

export const getUserInfo = (token) => {
  return axios.get('/info')
}

export const getRouter = (uid) => {
  return axios.post('/getRouter', uid)
}
